<template>
  <div class="goal-image-picker" v-on-click-away="hidePicker">
    <div class="grid grid-cols-4 col-gap-2 row-gap-2 -mx-2 -mt-2 mb-4">
      <GoalImagePickerTile v-for="(image,i) in goalsImages" :key="i"
                           :image="image.goal_image_url"
                           :name="image.title"
                           :active="activeImage && image.goal_image_url === activeImage.goal_image_url"
                           @click="$emit('select',image)"/>
    </div>
    <DropBoxFileUpload :accept="['jpg', 'jpeg', 'png', 'gif']"
                       @input="handleFileUpload($event)"/>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {directive as onClickAway} from "vue-clickaway";
import IconFileUpload from "@/components/icons/FileIcons/IconFileUpload";
import GoalImagePickerTile from "@/components/cabinet/Money/Goals/GoalImagePicker/GoalImagePickerTile";
import DropBoxFileUpload from "@/components/common/DropBoxFileUpload";

export default {
  name: "GoalImagePicker",
  directives: {
    onClickAway: onClickAway
  },
  components: {DropBoxFileUpload, GoalImagePickerTile, IconFileUpload},
  props: {
    activeImage: {
      type: Object
    }
  },
  data() {
    return {
      newImage: null,
    }
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ...mapGetters('space/goals', ['goalsImages']),
  },
  methods: {
    ...mapActions('space/goals', ['uploadGoalImage']),
    ...mapMutations('space/goals', ['pushUploadedGoalsImages']),
    async handleFileUpload(file) {
      this.newImage = file;
      try {
        let formData = new FormData();
        formData.append('file', this.newImage);
        const res = await this.uploadGoalImage(formData);
        if (res.body.success) {
          this.pushUploadedGoalsImages(res.body.data)
          this.$emit('select', res.body.data)
        } else {
          this.$toasted.error('Ошибка')
        }
      } catch (err) {
        console.error(err)
      }

    },
    hidePicker() {
      setTimeout(() => {
        this.$emit('hide', this.activeImage);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.goal-image-picker {
  @apply relative bg-white-top-gradient rounded-tl;
  padding: 1.8rem;

  &__tile {
    @apply p-2 border border-transparent rounded cursor-pointer transition duration-200;
    height: 97px;


    &:hover, &.active {
      @apply border-red;
    }

    img {
      @apply rounded;
      height: 100%;
      object-fit: cover;
    }
  }

  &:after {
    content: '';
    @apply absolute right-0;
    top: 101px;
    transform: translateX(100%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 7px solid var(--bg-primary-block);
  }
}
</style>